import React, { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { questionnaireResumeActions } from '../../../../core/questionnaire-resume/actions';
import { QuestionnaireProgress } from './QuestionnaireProgress';

export const NewMemberDiscovery = () => {
    const dispatch = useDispatch();
    const questionnaire_resume = useSelector(state => state.questionnaire_resume);
    const user = useSelector(state => state.user );

    useEffect(() => {
        dispatch(questionnaireResumeActions.loadQuestionnaireResume())
    }, [dispatch]);

    return (
        <div className="p-3">
            {user.account.questionnaire_presentation && 
                <div className="my-3 mt-md-2" dangerouslySetInnerHTML={{ __html: user.account.questionnaire_presentation }}></div>
            }
            
            <div className="questionnaire-resume-list grid-3">
                {
                    questionnaire_resume.data.map((questionnaire) =>
                        <Fragment key={questionnaire.id}>
                            <QuestionnaireProgress questionnaire={questionnaire} />
                        </Fragment>
                    )
                }
            </div>
        </div>
    )
}
